"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleTransport = exports.colorize = void 0;
// from browser-util-inspect
const colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39],
};
/**
 * Colorize a string with a specified color.
 * @param str String to colorize
 * @param color Color to colorize the string with
 * @returns Colorized string
 */
function colorize(str, color) {
    const colorData = colors[color];
    return '\u001b[' + colorData[0] + 'm' + str + '\u001b[' + colorData[1] + 'm';
}
exports.colorize = colorize;
/**
 * Gets a stack trace from metadata or accompanying error.
 */
function getStackTrace(data) {
    var _a;
    const stack = ((_a = data === null || data === void 0 ? void 0 : data.err) === null || _a === void 0 ? void 0 : _a.stack) || data.stack || data['error.stack'];
    delete data.stack;
    return stack !== null && stack !== void 0 ? stack : '';
}
function consoleTransport(config = {}) {
    var _a, _b, _c;
    // Default ignore patterns
    (_a = config.ignoreMetadataPatterns) !== null && _a !== void 0 ? _a : (config.ignoreMetadataPatterns = ['application', 'service', 'environment', 'version']);
    // Get the colorizer function, or a no-op if not enabled.
    const colorizer = config.colorize !== false ? (_b = config.colorize) !== null && _b !== void 0 ? _b : colorize : (str) => str;
    // Get the log level color function, or use the default colors.
    const getLogLevelColor = (_c = config.getLogLevelColor) !== null && _c !== void 0 ? _c : ((level) => {
        return {
            error: 'red',
            warn: 'yellow',
            info: 'cyan',
            debug: 'green',
        }[level];
    });
    const transport = {
        ...config,
        log: ({ level, message, timestamp, splat, ...metadata }) => {
            let splatData = splat !== null && splat !== void 0 ? splat : [];
            const stackTrace = getStackTrace(metadata);
            const strippedInfo = { ...metadata };
            delete strippedInfo['level'];
            delete strippedInfo['message'];
            delete strippedInfo['splat'];
            delete strippedInfo['timestamp'];
            delete strippedInfo['stack'];
            if (Object.keys(strippedInfo).length > 0) {
                splatData = [strippedInfo, ...splatData];
            }
            if (message) {
                splatData = [message, ...splatData];
            }
            if (stackTrace) {
                splatData = [...splatData, stackTrace];
            }
            console.log(`${colorizer(timestamp, 'magenta')} ${colorizer(level, getLogLevelColor(level))}: `, ...splatData);
        },
    };
    return transport;
}
exports.consoleTransport = consoleTransport;
//# sourceMappingURL=consoleTransport.js.map